import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LangProvider } from './context/LangContext';
import Globe              from './components/Globe';
import Header             from './components/Header';
import CtaGrid            from './components/CtaGrid';
import Footer             from './components/Footer';
import Nosotros           from './pages/Nosotros';
import Contacto           from './pages/Contacto';
import MercadosEmergentes from './pages/MercadosEmergentes';
import LegalesGenerales   from './pages/LegalesGenerales';
import Privacidad         from './pages/Privacidad';
import TerminosCondiciones from './pages/TerminosCondiciones';
import Cookies            from './pages/Cookies';
import EnviosDevoluciones from './pages/EnviosDevoluciones';
import CodigoEtica        from './pages/CodigoEtica';
import CentroAyuda        from './pages/CentroAyuda';

export function HomePage() {
  useEffect(() => {
    function centerGlobe() {
      if (window.innerWidth <= 768) return;
      const header = document.querySelector('header');
      const footer = document.querySelector('footer');
      const globe  = document.querySelector('.globe-wrap');
      if (!header || !footer || !globe) return;
      const centerY = (header.getBoundingClientRect().bottom + footer.getBoundingClientRect().top) / 2;
      globe.style.top = centerY + 'px';
    }
    centerGlobe();
    window.addEventListener('resize', centerGlobe);
    return () => window.removeEventListener('resize', centerGlobe);
  }, []);

  return (
    <>
      <Globe />
      <div className="page">
        <Header />
        <main><CtaGrid /></main>
        <Footer />
      </div>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <Routes>
          <Route path="/"                          element={<HomePage />} />
          <Route path="/nosotros"                  element={<Nosotros />} />
          <Route path="/contacto"                  element={<Contacto />} />
          <Route path="/mercados-emergentes"       element={<MercadosEmergentes />} />
          <Route path="/centro-de-ayuda"           element={<CentroAyuda />} />
          <Route path="/legal/legales-generales"   element={<LegalesGenerales />} />
          <Route path="/legal/privacidad"          element={<Privacidad />} />
          <Route path="/legal/terminos-condiciones" element={<TerminosCondiciones />} />
          <Route path="/legal/cookies"             element={<Cookies />} />
          <Route path="/legal/envios-devoluciones" element={<EnviosDevoluciones />} />
          <Route path="/legal/codigo-etica"        element={<CodigoEtica />} />
        </Routes>
      </LangProvider>
    </BrowserRouter>
  );
}
